// extracted by mini-css-extract-plugin
export default {"wrap_blog":"Blog_wrap_blog__aPVKJ","list":"Blog_list__LT7-e"};